// Tier 1: Genre/era anchor terms — Suno has strong training associations
export const TIER_1_GENRE_ANCHORS: string[] = [
  // Core genre tags
  'southern rock', 'blues rock', 'outlaw country', 'doom metal', 'soul', 'r&b',
  'funk', 'motown', 'gospel', 'americana', 'country', 'hard rock', 'classic rock',
  'folk', 'jazz', 'hip hop', 'trap', 'pop', 'indie rock', 'punk', 'metal',
  'grunge', 'psychedelic', 'bossa nova', 'reggae', 'ska', 'lo-fi', 'synthwave',
  'new wave', 'post-punk', 'shoegaze', 'dream pop', 'ambient', 'electronic',
  'house', 'techno', 'dubstep', 'drum and bass', 'garage rock', 'alt rock',
  'prog rock', 'art rock', 'math rock', 'emo', 'screamo', 'hardcore',
  'metalcore', 'death metal', 'black metal', 'thrash metal', 'power metal',
  'stoner rock', 'sludge metal', 'grindcore', 'noise rock', 'industrial',
  'darkwave', 'goth rock', 'trip hop', 'downtempo', 'chillwave',
  'neo soul', 'contemporary r&b', 'quiet storm', 'disco', 'boogie',
  'bluegrass', 'honky tonk', 'western swing', 'rockabilly', 'surf rock',
  'doo wop', 'barbershop', 'acapella', 'choral', 'orchestral', 'cinematic',
  'latin', 'afrobeat', 'highlife', 'dancehall', 'reggaeton', 'cumbia',
  'flamenco', 'klezmer', 'celtic', 'world music', 'new age', 'classical',
  'baroque', 'romantic era', 'impressionist',
  // Era modifiers
  '60s', '70s', '80s', '90s', '2000s', 'retro', 'vintage', 'modern', 'contemporary',
  // Sub-genre specifics from HookHouse genres
  'minneapolis sound', 'philly soul', 'muscle shoals', 'stax', 'bakersfield sound',
  'nashville sound', 'countrypolitan', 'southern metal', 'choral sludge',
  'album oriented rock', 'aor', 'west coast hip hop', 'g-funk',
];

// Tier 2: Behavioral/evocative language — Suno responds well to these
export const TIER_2_BEHAVIORAL: string[] = [
  // From HookHouse genre moodKeywords (harvested)
  'intimate', 'sensual', 'whispered', 'vulnerable', 'tender', 'confident',
  'magnetic', 'unstoppable', 'bold', 'dignified', 'composed', 'bittersweet',
  'graceful', 'yearning', 'hopeful', 'devoted', 'deliberate', 'charged',
  'focused', 'hazy', 'content', 'uncertain', 'rolling', 'endless', 'free',
  'contemplative', 'weathered', 'honest', 'tired', 'wise', 'proud', 'defiant',
  'unapologetic', 'unified', 'restless', 'romantic', 'wandering', 'mournful',
  'respectful', 'heavy', 'eternal', 'greasy', 'funky', 'sweaty', 'dangerous',
  'humble', 'searching', 'rising', 'driving', 'grinding', 'swampy', 'haunting',
  'gritty', 'raw', 'dirty', 'smooth', 'warm', 'bright', 'dark', 'aggressive',
  'melancholy', 'epic', 'spacious', 'punchy', 'light', 'dreamy', 'thundering',
  'soaring', 'weeping', 'angular', 'loose', 'tight', 'brooding', 'explosive',
  'fierce', 'hypnotic', 'crushing', 'relentless', 'triumphant', 'atmospheric',
  'eerie', 'ominous', 'desolate', 'bleak', 'sparse', 'lush', 'dense',
  'shimmering', 'pulsing', 'throbbing', 'aching', 'crying', 'wailing',
  'growling', 'screaming', 'whispering', 'chanting', 'droning',
  // Texture descriptors
  'crunchy', 'fuzzy', 'clean', 'distorted', 'overdriven', 'saturated',
  'muddy', 'crisp', 'sharp', 'dull', 'ringing', 'buzzing', 'humming',
];

// Tier 3: Scene/atmosphere cue words
export const TIER_3_MOOD: string[] = [
  'midnight', 'roadhouse', 'swamp', 'barroom', 'arena', 'stadium', 'basement',
  'cathedral', 'desert', 'rain', 'smoke', 'neon', 'highway', 'back porch',
  'juke joint', 'honky tonk', 'dive bar', 'church', 'graveyard', 'bayou',
  'delta', 'mountain', 'ocean', 'forest', 'city', 'urban', 'rural',
  'southern', 'northern', 'coastal', 'dusty', 'smoky', 'hazy', 'foggy',
  'sunset', 'sunrise', 'twilight', 'dusk', 'dawn', 'night', 'moonlit',
  'starlit', 'candlelit', 'firelight', 'campfire', 'bonfire',
  'summer', 'winter', 'autumn', 'spring', 'stormy', 'thunderstorm',
  'rainy', 'sunny', 'overcast', 'humid', 'hot', 'cold', 'frozen',
  'late night', 'early morning', 'sunday morning', 'saturday night',
];

// Tier 4: Soft technical — Suno may interpret these
export const TIER_4_SOFT_TECHNICAL: string[] = [
  'reverb', 'distortion', 'overdrive', 'tremolo', 'vibrato', 'slide guitar',
  'palm mute', 'fingerpicking', 'staccato', 'legato', 'falsetto',
  'double tracked', 'layered', 'octave', 'harmony', 'unison',
  'call and response', 'a cappella', 'acoustic', 'electric', 'unplugged',
  'stripped down', 'full band', 'solo', 'duet', 'choir', 'orchestra',
  'crescendo', 'decrescendo', 'fade in', 'fade out', 'breakdown',
  'build up', 'drop', 'bridge', 'outro', 'intro', 'verse', 'chorus',
  'hook', 'riff', 'groove', 'beat', 'rhythm', 'melody', 'bassline',
  'syncopated', 'swing', 'shuffle', 'straight', 'triplet',
  'minor key', 'major key', 'modal', 'pentatonic', 'blues scale',
];

// Dead-weight terms — Suno has NO meaningful pattern for these
export const DEADWEIGHT_TERMS: string[] = [
  // DAW-specific engineering
  'sidechain', 'sidechain compression', 'compression ratio', 'attack time',
  'release time', 'threshold', 'gain staging', 'headroom', 'latency',
  'buffer size', 'sample rate', 'bit depth', 'dither', 'limiter',
  'bus compression', 'mid-side', 'multiband', 'parallel compression',
  'send return', 'aux send', 'insert', 'rack mount',
  // Frequency engineering
  'hpf', 'lpf', 'eq curve', 'notch filter', 'shelf', 'hz', 'khz',
  'frequency spectrum', 'harmonic distortion', 'thd', 'nyquist',
  'high pass filter', 'low pass filter', 'band pass', 'parametric eq',
  // MIDI/pitch technical
  'pitch_bend', 'cents', 'midi velocity', 'cc message', 'cc#',
  'modulation wheel', 'aftertouch', 'portamento ms', 'glide time',
  'pitch bend range', 'midi channel',
  // Mixing ratios and measurements
  'ratio', ':1', 'ms delay', 'tap tempo', 'phase alignment',
  'db', 'dbfs', 'lufs', 'rms', 'peak level', 'true peak',
  'stereo width', 'panning law', 'pan pot',
  // Software/DAW names
  'vst', 'plugin', 'daw', 'pro tools', 'logic pro', 'ableton',
  'fl studio', 'kontakt', 'omnisphere', 'waves', 'fabfilter',
  'izotope', 'ozone', 'neutron', 'serum', 'massive', 'sylenth',
  // Notation-specific
  'time signature', 'bar line', 'staff', 'clef', 'accidental',
  'ledger line', 'figured bass', 'tablature',
  // Recording technical
  'proximity effect', 'off-axis', 'polar pattern', 'cardioid',
  'condenser', 'dynamic mic', 'ribbon mic', 'phantom power',
  'impedance', 'preamp gain', 'signal to noise',
];

// Suggested replacements for common technical terms
export const TERM_SUBSTITUTIONS: Record<string, string> = {
  'pitch bend': 'crying slow bend that aches',
  'vibrato': 'wavering note that breathes',
  'tremolo picking': 'shivering string texture',
  'heavy reverb': 'cavernous room sound with long trails',
  'compression': 'punchy and controlled',
  'heavy distortion': 'saturated grinding crunch',
  'palm muting': 'chugging rhythmic mutes',
  'staccato': 'clipped sharp attack',
  'falsetto': 'breathy upper register',
  'fingerpicking': 'delicate fingerstyle',
  'sidechain': 'pumping rhythm',
  'low pass filter': 'muffled underwater tone',
  'high pass filter': 'thin telephone vocal',
  'delay': 'echoing repeats',
  'chorus effect': 'shimmering doubled texture',
  'flanger': 'jet engine swoosh',
  'phaser': 'swirling underwater phase',
  'wah': 'crying wah-wah',
  'overdrive': 'warm tube crunch',
  'fuzz': 'thick buzzy sustain',
  'clean tone': 'crystal clear bell-like guitar',
  'drop tuning': 'low heavy tuning',
  'double bass drum': 'rapid-fire kick drum assault',
  'blast beat': 'machine gun drumming',
};

// All terms combined into a single lookup for quick tier classification
export function getTermTier(term: string): 1 | 2 | 3 | 4 | 5 | 0 {
  const lower = term.toLowerCase();
  if (DEADWEIGHT_TERMS.some(d => lower.includes(d.toLowerCase()))) return 5;
  if (TIER_1_GENRE_ANCHORS.some(g => lower.includes(g.toLowerCase()))) return 1;
  if (TIER_2_BEHAVIORAL.some(b => lower === b.toLowerCase())) return 2;
  if (TIER_3_MOOD.some(m => lower.includes(m.toLowerCase()))) return 3;
  if (TIER_4_SOFT_TECHNICAL.some(t => lower.includes(t.toLowerCase()))) return 4;
  return 0;
}
